<template>
  <Dashboard />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useCurrentUserStore } from '@/stores/currentUser.ts';
import Dashboard from './Dashboard.vue';

const router = useRouter();
const currentUserStore = useCurrentUserStore();

onMounted(() => {
  const kickToNewAgentPortal = currentUserStore.isAgent();
  if (kickToNewAgentPortal) router.push({ name: 'Agent My Task List' });
});
</script>
